var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-input',_vm._b({directives:[{name:"c-focus",rawName:"v-c-focus"}],class:_vm.invalidClass,attrs:{"type":"text","placeholder":"Enter code","name":"code"},on:{"input":_vm.updateValue}},'c-input',{ value: _vm.value },false))}
var staticRenderFns = []

export { render, staticRenderFns }